/**
 * @hidden
 */
export var animate = function animate(transition, offset, animationFrame) {
  if (offset === void 0) {
    offset = 0;
  }
  if (animationFrame === void 0) {
    animationFrame = 0;
  }
  var duration = transition.duration;
  var start;
  var progress;
  var skip = offset && 1 - offset;
  if (transition.onStart) {
    transition.onStart();
  }
  var frame = function frame(timestamp) {
    if (!start) {
      start = timestamp;
    }
    progress = timestamp - start + 1;
    var rate = progress / duration + skip;
    if (rate <= 1) {
      if (transition.onUpdate) {
        transition.onUpdate(rate);
      }
      animationFrame = window.requestAnimationFrame(frame);
      offset = rate;
    } else {
      if (transition.onEnd) {
        transition.onEnd(1);
      }
      offset = 0;
    }
  };
  animationFrame = window.requestAnimationFrame(frame);
  return animationFrame;
};
/**
 * @hidden
 */
export var cancelAnimation = function cancelAnimation(animationFrame) {
  if (animationFrame) {
    window.cancelAnimationFrame(animationFrame);
  }
};